export default {
  deliverymen: [],
  allyMarkers: [],
};
